import React from 'react'
import HeroDigitalMarketing from '../components/digital marketing/hero'
import Aboutdigital from '../components/digital marketing/aboutdigital'
import Whydigital from '../components/digital marketing/whydigital'
import Digitalservices1 from '../components/digital marketing/digitalservices'
import Whyyouneed1 from '../components/digital marketing/whyyouneed'
import Reviews from '../components/Reviews'
import Howdigital from '../components/digital marketing/howdigital'
import Cardsdigital from '../components/digital marketing/cardsdigital'
import Whychose1 from '../components/digital marketing/whychose'
import Whychosecard1 from '../components/digital marketing/whychosecard'
import Rewarddigital1 from '../components/digital marketing/rewarddigital'
import Faqdigitalmarketing1 from '../components/faqdigitalmarketing'
import Form1 from '../components/herosection/form'
import Landingcontact from '../components/landingcontact'

function Digitalmarketingmain() {
    return (
        <div>
            <HeroDigitalMarketing />
            <Aboutdigital />
            <Whydigital />
            <Reviews />
            <Howdigital />
            <Cardsdigital />
            <Digitalservices1/>
            <Whyyouneed1 />
            <Whychose1/>
            <Whychosecard1/>
            <Rewarddigital1/>
            <Faqdigitalmarketing1/>
            <Form1/>
            <Landingcontact/>
        </div>
    )
}

export default Digitalmarketingmain